import { render, staticRenderFns } from "./DebtorSupplierBusinessRelationModal.vue?vue&type=template&id=616b6d82&"
import script from "./DebtorSupplierBusinessRelationModal.vue?vue&type=script&lang=js&"
export * from "./DebtorSupplierBusinessRelationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports